import React from 'react'
import { INPUT_BASE } from './constants'
import { Label } from './Label'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string; hint?: string; error?: string; containerStyle?: React.CSSProperties
}

export const TextInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, hint, error, style, disabled, containerStyle, ...rest }, ref) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', ...containerStyle }}>
      {label && <Label>{label}</Label>}
      <input ref={ref} disabled={disabled} style={{ ...INPUT_BASE, ...(error ? { borderColor: 'var(--status-error)' } : {}), ...(disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {}), ...style }} {...rest} />
      {error && <span style={{ fontSize: '0.75rem', color: 'var(--status-error)' }}>{error}</span>}
      {hint && !error && <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{hint}</span>}
    </div>
  )
)
TextInput.displayName = 'TextInput'
